import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Box,
    Button,
    TextField,
    Typography,
    Paper,
    Alert,
    CircularProgress,
} from '@mui/material';
import { Email } from '@mui/icons-material';
import api from '../services/api';

const ResetPassword = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState(null);

    const handleValidEmail = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        setMessage(null);

        try {
            const response = await api.post('/users/verify-email', { email });
            setMessage(response.data.message || 'Link de redefinição enviado com sucesso!');
        } catch (err) {
            setError('Falha ao enviar o link de redefinição.');
            // Log do erro para depuração: console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const isEmailValid = () => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: '#f5f5f5',
            }}
        >
            <Paper
                elevation={6}
                sx={{
                    display: 'flex',
                    width: '100%',
                    maxWidth: 550,
                    borderRadius: 4,
                    overflow: 'hidden',
                }}
            >
                <Box
                    sx={{
                        flex: 1,
                        p: 4,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        bgcolor: 'white',
                    }}
                >
                    <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 3, textAlign: 'center' }}>
                        Redefinir Senha
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 3, textAlign: 'center', color: 'text.secondary' }}>
                        Informe seu e-mail e enviaremos um link para você redefinir sua senha.
                    </Typography>
                    <Box component="form" onSubmit={handleValidEmail} sx={{ width: '100%' }}>
                        <TextField
                            fullWidth
                            label="Email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            error={!!email && !isEmailValid()}
                            helperText={!!email && !isEmailValid() ? 'Email inválido' : ''}
                            margin="normal"
                            variant="outlined"
                            sx={{
                                '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#10641c',
                                },
                                '& .MuiInputLabel-root.Mui-focused': {
                                    color: '#10641c',
                                },
                            }}
                        />

                        {error && (
                            <Alert severity="error" sx={{ mt: 2 }}>
                                {error}
                            </Alert>
                        )}
                        {message && (
                            <Alert severity="success" sx={{ mt: 2 }}>
                                {message}
                            </Alert>
                        )}

                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            disabled={loading || !isEmailValid()}
                            sx={{ mt: 3, py: 1.5, bgcolor: '#10641c', '&:hover': { bgcolor: '#0e5517' } }}
                        >
                            {loading ? <CircularProgress size={24} /> : 'ENVIAR LINK'}
                        </Button>

                        <Button
                            fullWidth
                            variant="outlined"
                            onClick={() => navigate('/login')}
                            sx={{
                                py: 1.5,
                                borderColor: '#10641c',
                                color: '#10641c',
                                '&:hover': {
                                    borderColor: '#0e5517',
                                    bgcolor: 'rgba(16, 100, 28, 0.08)',
                                },
                                mt: 1,
                            }}
                        >
                            VOLTAR
                        </Button>
                    </Box>
                </Box>
            </Paper>
        </Box>
    );
};

export default ResetPassword;